/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used in the Component Set Details screen.
 * @export
 */
export const COMPONENT_SET_DETAILS_DATA_IDS = {
  actions: `Component set details actions`,
  addToSetButton: `Add to set button`,
  componentDetailsVersionsSetManagementEditButton: `Component set details versions set management edit button`,
  createComponentSetDialogButton: 'Create component set dialog button',
  emptyStateIcon: `Component set components empty state icon`,
  openEnvVarDialogButton: `open env dialog button`,
  openHeadersDialogButton: `open headers dialog button`,
  setConfigList: `Set configuration list`,
  setDescription: `Component set description`,
};

export const COMPONENT_SET_DETAILS_CONSTANTS = {
  maxDescriptionLength: 100,
  maxDisplayNameLength: 65,
};
